import dynamic from "next/dynamic";
import { useState, useRef, useEffect } from "react";

import { ReferalsContainer } from "./Referals.styled";

const SwiperReferals = dynamic(
  () =>
    import("./SwiperReferals").then(mod => ({ default: mod.SwiperReferals })),
  {
    ssr: false,
    loading: () => (
      <div
        style={{
          minHeight: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Loading testimonials...
      </div>
    ),
  },
);

interface ReferalsProps {
  className?: string;
}

export const Referals = ({ className }: ReferalsProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <ReferalsContainer ref={containerRef} className={className}>
      {isVisible && <SwiperReferals />}
    </ReferalsContainer>
  );
};
